import './Progressbar.scss'

import React from 'react'
import {number_format} from '../../util/price'
import {style} from '../../util/style'

const styles = style('progressbar')

export type ProgressbarType = {
	className?: string
	value: number
	text?: string
	total: number
}

export const Progressbar: React.FC<ProgressbarType> = ({
	className,
	value,
	text,
	total
}) => {
	if (!value && !total) return null
	const percent = value > 0 && value >= total ? 100 : (value / total) * 100
	const totalHasDecimals: boolean = total - Math.floor(total) !== 0
	const amount: string = number_format(value, 2, ',', '.') + ' euro'
	const totalAmount: string =
		'€' + number_format(total, totalHasDecimals ? 2 : 0, ',', '.')

	return (
		<div
			className={styles()
				.with(className)
				.mod({full: value >= total})}
		>
			<div
				className={styles('value')}
				style={{transition: 'width 2s ease-in-out', width: percent + '%'}}
			/>
			<p className={styles('value-text')}>
				{text ? text.replace('€', amount) : amount}
			</p>
			{total && <p className={styles('total')}>{totalAmount}</p>}
		</div>
	)
}
